module.exports = __webpack_public_path__ + "img/field-hockey-stick-ball.719fc69c.svg";